export enum ScreenSizeAction {
  SET_DESKTOP_BIG_SIZE = 'SET_DESKTOP_BIG_SIZE',
  SET_DESKTOP_SIZE = 'SET_DESKTOP_SIZE',
  SET_PHONE_SIZE = 'SET_PHONE_SIZE',
  SET_TABLET_LANDSCAPE_SIZE = 'SET_TABLET_LANDSCAPE_SIZE',
  SET_TABLET_PORTRAIT_SIZE = 'SET_TABLET_PORTRAIT_SIZE',
}

export enum DetailViewAction {
  SET_DETAIL_VISIBILITY = 'SET_DETAIL_VISIBILITY',
}

export enum ExportDialog {
  SET_EXPORT_DIALOG_VISIBILITY = 'SET_EXPORT_DIALOG_VISIBILITY',
}

export enum ConsentBannerAction {
  HIDE_CONSENT_BANNER = 'HIDE_CONSENT_BANNER',
}
